<div class="container-fluid">
    <!--opções listagem-->
    <div class="row container-fluid mt-5 mb-4 mx-auto p-0">
        <div class="col-6">
            <div class="row h-100">
                <!-- <div class="espacamento">
                    <input name="busca" id="busca" [(ngModel)]="filtroPesquisa" type="text" class="form-control textbox-n input-font-size h-auto" placeholder="Busca">
                </div>
                <div class="espacamento">
                <div class="mt-2" [ngClass]="{'active': cancelCount > 0}"><span class="list-filter" style="align-self: center; cursor: pointer;"
                        (click)="selectAll = !selectAll;selectAllToCancel(selectAll);">Selecionar tudo</span></div>
                </div> -->
                <!--<div class="espacamento">
                    <div class="mt-2" (click)="showCancelAll(cancelallmodal);" [ngClass]="{'active': cancelCount > 0}"><span  class="list-filter" style="align-self: center; cursor: pointer;">Cancelar recarga(s)</span></div>
                </div>-->
                <!--<div class="list-select-all mr-4 my-1" [ngClass]="{'active': cancelCount > 0}"><img
                        [src]="(cancelCount > 0) ? '/assets/icons/check-purple.png':'/assets/icons/check-grey.png'"
                        width="auto" height="20px" /> <span class="mx-2"
                        (click)="selectAll = !selectAll;selectAllToCancel(selectAll);">Selecionar tudo</span></div>-->
                <!-- <div (click)="showCancelAll(cancelallmodal);" class="list-delete mr-4 my-1" [ngClass]="{'active': cancelCount > 0}"><img [src]="(cancelCount > 0) ? '/assets/icons/garbage-purple.png':'/assets/icons/garbage-grey.png'" width="auto" height="20px" /> <span class="mx-2">Cancelar</span></div> -->
            </div>
        </div>


        <div class="col-6">
            <div class="row h-100">
                <div class="list-filter-show-item ml-auto">Mostrar:
                    <select [(ngModel)]="showItem" (ngModelChange)="changeLimit($event)">
                        <option [ngValue]="10" value="10" selected>10</option>
                        <option [ngValue]="25" value="25">25</option>
                        <option [ngValue]="50" value="50">50</option>
                        <option [ngValue]=100 value="100">100</option>
                    </select>
                </div>
            </div>
        </div>
    </div>

    <div class="table-overflow">
        <div class="text-center" *ngIf="messageError != null">
            <p>{{messageError}}</p>
        </div>
        <table class="list-table table" *ngIf="messageError === null">
            <thead class="list-table-head">
                <!--<th></th>-->

                <th class="" (click)="sortOrder = !sortOrder; orderBy('purchaseId', sortOrder)">Código da recarga</th>
                <th class="" (click)="sortOrder = !sortOrder; orderBy('purchaseDate', sortOrder)">Data da recarga</th>
                <th class="" (click)="sortOrder = !sortOrder; orderBy('purchaseDescription', sortOrder)">Descrição da recarga</th>
                <th class="" (click)="sortOrder = !sortOrder; orderBy('purchaseValue', sortOrder)">Valor</th>
                <th class="" (click)="sortOrder = !sortOrder; orderBy('releaseDate', sortOrder)">Data de liberação</th>
                <th class="" (click)="sortOrder = !sortOrder; orderBy('purchaeStateDescription', sortOrder)">Situação</th>

                <th></th>
            </thead>

            <tbody class="list-table-row">
                <tr *ngFor=" let item of purchasesList | paginate: { itemsPerPage: showItem, currentPage: currentPage, totalItems: totalPurchases } |
                    searchPedidosSalvos: filtroPesquisa; let i = index;" class=" list-table-cell">
                    <!--<td class="clickable" (click)="item.toCancel = !item.toCancel; updateCancelCount();">
                        <span class="mx-2">
                            <input [attr.id]="item.purchaseId" type="checkbox" class="radio-checkbox"
                                [(ngModel)]="item.toCancel"
                                (click)="item.toCancel = !item.toCancel; updateCancelCount();" />
                            <label [attr.for]="item.purchaseId" class="radio-label"></label>
                        </span>
                    </td>-->
                    <td class="clickable" (click)="item.toCancel = !item.toCancel; updateCancelCount();">
                        {{item.purchaseId}}</td>
                    <td class="clickable" (click)="item.toCancel = !item.toCancel; updateCancelCount();">
                        {{item.purchaseDate | date: 'dd/MM/yyyy'}}</td>
                    <td class="clickable" (click)="item.toCancel = !item.toCancel; updateCancelCount();">
                        {{item.purchaseDescription}}</td>
                    <td class="clickable" (click)="item.toCancel = !item.toCancel; updateCancelCount();">
                        {{item.purchaseValue | currency:'BRL':true}}</td>
                    <td class="clickable" (click)="item.toCancel = !item.toCancel; updateCancelCount();">
                        {{item.releaseDate | date: 'dd/MM/yyyy HH:mm'}}</td>
                    <td class="clickable" (click)="item.toCancel = !item.toCancel; updateCancelCount();">
                        {{item.purchaseStateDescription}} <!--<span *ngIf="item.situacaoId === SituacaoPedido.Cancelado">por
                            {{item.gestorNomeAlteracao}}</span>--></td>

                    <td>
                        <div ngbDropdown class="d-inline-block menu-option">
                            <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle><img
                                    src="assets/icons/menu.png" /></button>
                            <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                <section class="custom-context-menu">
                                    <div ngbDropdownItem (click)="details(item)"><img src="assets/icons/pencil-purple.png" class="mr-2" />Detalhes da recarga
                                    </div>
                                    <div ngbDropdownItem *ngIf="item.purchaseState === SituacaoCompra.ParcialmenteProcessado || item.purchaseState === SituacaoCompra.NaoProcessado" (click)="showReprocessar(reprocessarmodal,item);"><img src="assets/icons/pencil-purple.png" class="mr-2" />Reprocessar recarga</div>
                                    <!--<div ngbDropdownItem (click)="copiar(item)"><img src="assets/icons/pencil-purple.png" class="mr-2">Copiar recarga</div>-->
                                    <!--<div ngbDropdownItem *ngIf="item.purchaseState === SituacaoCompra.EmCriacao || item.purchaseState === SituacaoCompra.Criado || item.purchaseState === SituacaoCompra.NaoProcessado" (click)="showCancel(cancelmodal,item);"><img src="assets/icons/garbage-purple.png" class="mr-2" />Cancelar recarga</div>-->
                                </section>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="page-custom mt-2" *ngIf="messageError === null">
        <pagination-controls (pageChange)="changePage($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
    </div>
</div>

<!--Modal de Reprocesar-->
<ng-template #reprocessarmodal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Reprocessar Recarga</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <p class="col-12 clean-modal-subtitle" style="font-size: 20px;">
            Tem certeza que deseja reprocessar a recarga de código:
            <span style="color:#313840; font-weight: bold;"> {{pedidoToReprocessar.purchaseId}}?</span>
        </p>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-filter-button custom-filter-button-just" type="button"
            (click)="reprocessar(pedidoToReprocessar);modal.dismiss('Close click')">
            Reprocessar
        </button>
    </div>
</ng-template>

<!--Modal do Cancelar-->
<ng-template #cancelmodal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Cancelar recarga
            </h5>
            <p class="clean-modal-subtitle" style="font-size: 20px;">
                Tem certeza que deseja cancelar a recarga de código:
                <span style="color:#313840; font-weight: bold;"> {{pedidoToCancel.purchaseId}}?</span>
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click')">NÃO</button>
        <button class="custom-filter-button custom-filter-button-just" type="button" type="button" (click)="cancel(pedidoToCancel);modal.dismiss('Close click')">SIM</button>
    </div>
</ng-template>

<!--Modal do Cancelar Vários-->
<ng-template #cancelallmodal let-modal>
        <div class="col-12 modal-header clean-modal-header">
            <div class="col-md-12">
                <h5 class="modal-title clean-modal-title">
                    Cancelar recarga(s)
                </h5>
                <p class="clean-modal-subtitle" style="font-size: 20px;">
                    Tem certeza que deseja cancelar
                    <span style="color:#313840; font-weight: bold;"> {{cancelCount}} </span> recarga(s) ?
                </p>
            </div>
        </div>
        <div class="col-12 clean-modal-footer">
            <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click')">NÃO</button>
            <button class="custom-filter-button custom-filter-button-just" type="button" [disabled]="cancelCount < 1" (click)="cancelAllSelected();modal.dismiss('Close click')">SIM</button>
        </div>
</ng-template>
